import { Button, Flex, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useGovEvaluationOpen } from '@/module/GovEvaluation/model/GovEvaluationQuery';

import { Content } from '@/core/components';

import { useAppNotification } from '@feature/utils';

interface OpenEvaluationBoxProps {
  year: number;
}

export function OpenGovEvaluationBox({ year }: OpenEvaluationBoxProps) {
  const { t } = useTranslation();
  const notification = useAppNotification();
  const { mutate, isPending } = useGovEvaluationOpen(year);

  const onClick = () => {
    mutate(undefined, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <Content type="full">
      <Flex
        justify="space-between"
        align="center"
      >
        <Text fw="500">
          {t('govEvaluation.openTitle')} {year}
        </Text>
        <Button
          size="sm"
          onClick={onClick}
          loading={isPending}
        >
          {t('button.open')}
        </Button>
      </Flex>
    </Content>
  );
}
